import { ImageIcon, UploadIcon } from "lucide-react";
import { MediaFieldsFragment } from "@/gql/graphql";
import { ImoovaImage } from "@/app/Media/Components/Image";
import { Spinner } from "@/lib/Components/Layout/Loaders/Spinner";
import { SupplierImageDropzoneState } from "@/app/Suppliers/Hooks/useSupplierImageDropzone";
import { cn } from "@/lib/utils";

export function SupplierImagePreview({
  dropzone,
  media,
  label,
  className,
}: {
  dropzone: SupplierImageDropzoneState;
  media: MediaFieldsFragment | null | undefined;
  label: string;
  className: string;
}) {
  const { isDragActive, isUploading } = dropzone;

  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center overflow-hidden",
        media
          ? "border-2 border-transparent"
          : "border-2 border-dashed border-gray-300 bg-gray-50 text-gray-400 group-hover:border-gray-400 group-hover:text-gray-600",
        isDragActive && "border-indigo-500 bg-indigo-50 text-indigo-500",
        className,
      )}
    >
      {media ? (
        <ImoovaImage
          media={media}
          alt={label}
          className="size-full object-contain"
        />
      ) : (
        <ImageIcon className="size-4" aria-hidden />
      )}
      {media && !isUploading ? (
        <div
          className={cn(
            "absolute inset-0 flex items-center justify-center bg-black/50 text-white opacity-0 transition-opacity group-hover:opacity-100",
            isDragActive && "opacity-100",
          )}
        >
          <UploadIcon className="size-4" aria-hidden />
        </div>
      ) : null}
      {isUploading ? (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70">
          <Spinner />
        </div>
      ) : null}
    </div>
  );
}

export function SupplierImageDropzone(
  props: Parameters<typeof SupplierImagePreview>[0],
) {
  const { getRootProps, getInputProps } = props.dropzone;

  return (
    <div
      {...getRootProps()}
      title={props.label}
      className="group cursor-pointer"
    >
      <input {...getInputProps()} />
      <SupplierImagePreview {...props} />
    </div>
  );
}
